// src/components/Footer.js
import React from "react";
import "./Footer.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLinkedinIn,
  faYoutube,
  faXTwitter,
  faFacebookF,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';
import { faMicrophone } from '@fortawesome/free-solid-svg-icons'; 
import meta from './Assets/Badge-MBP.svg';
import trust from './Assets/Badge-TEM.svg';
import logo from './Assets/download.png';
import ias from './Assets/Badge-IAS.svg';

const Footer = () => {
  const icons = [
    { icon: faLinkedinIn, link: '#' },
    { icon: faYoutube, link: '#' },
    { icon: faXTwitter, link: '#' },
    { icon: faFacebookF, link: '#' },
    { icon: faInstagram, link: '#' },
    { icon: faMicrophone, link: '#' },
  ];
  const contactData = [
    {
      region: 'Americas – Atlanta, GA, USA',
      number: '+1 844–84–SINCH',
      time: 'Mon–Friday 9AM–6PM EST',
    },
    {
      region: 'EMEA – Stockholm, Sweden',
      number: '+46 8 446 828 03',
      time: 'Mon–Friday 8AM–5PM CET',
    },
    {
      region: 'APAC – Singapore',
      number: '+65 315 83155',
      time: 'Mon–Friday 9AM–6PM UTC',
    },
  ];


  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-logo">
        <img src={logo} alt="Logo" />
          <button className="btn-expert">Talk to an expert</button>
        </div>

        <div className="footer-social">
          <p>Follow us</p>
          <div className="icon-container">
      {icons.map((item, index) => (
        <a href={item.link} className="icon-button" key={index}>
          <FontAwesomeIcon icon={item.icon} />
        </a>
      ))}
    </div>
        </div>
      </div>

      <div className="footer-links">
        <div>
          <h4>Applications</h4>
          <ul>
            <li>Messaging platform</li>
            <li>Chatbot builder</li>
            <li>Contact center</li>
            <li>Email marketing</li>
            <li>View all apps</li>
          </ul>
        </div>
        <div>
          <h4>APIs</h4>
          <ul>
            <li>Messaging APIs</li>
            <li>Verification APIs</li>
            <li>Email APIs</li>
            <li>Calling APIs</li>
            <li>Campaigns</li>
            <li>Numbers</li>
            <li>View all APIs</li>
          </ul>
        </div>
        <div>
          <h4>Network</h4>
          <ul>
            <li>Telco</li>
            <li>View all network solutions</li>
          </ul>
        </div>
        <div>
          <h4>Solutions</h4>
          <ul>
            <li>Marketing Teams</li>
            <li>Operations</li>
            <li>Customer Service</li>
            <li>Conversational Marketing</li>
            <li>Conversational Commerce</li>
            <li>Conversational Care</li>
            <li>Mobile Identity & Security</li>
            <li>View all solutions</li>
          </ul>
        </div>
        <div>
          <h4>Resources</h4>
          <ul>
            <li>Sinch Super Network</li>
            <li>Blog</li>
            <li>Customer Stories</li>
            <li>Video & Webinars</li>
            <li>Sinch AI</li>
            <li>Help center</li>
          </ul>
        </div>
        <div>
          <h4>Company</h4>
          <ul>
            <li>About us</li>
            <li>Why Sinch</li>
            <li>Careers</li>
            <li>Contact us</li>
            <li>Investors</li>
            <li>News</li>
            <li>Partners</li>
            <li>Security</li>
            <li>Glossary</li>
          </ul>
        </div>
      </div>

      <div className="contact-wrapper">
      <div className="contact-columns">
        {contactData.map((item, idx) => (
          <div className="contact-box" key={idx}>
            <strong>{item.region}</strong>
            <p className="contact-number">
              <a href={`tel:${item.number}`}>{item.number}</a> <span>→</span>
            </p>
            <p className="contact-time">{item.time}</p>
          </div>
        ))}
      </div>

      <div className="cert-logos">
        <img src={meta} alt="Meta" />
        <img src={trust} alt="Trust Messaging" />
        <img src={ias} alt="IAS" />
      </div>
    </div>
    </footer>
  );
};

export default Footer;
